import dt from 'dayjs'
import * as lib from '../lib'
import {
	type IFetchItems,
	type IFetchOfferSpendByOffer,
	type TFetchOfferSpendByOfferAggregated,
	type TOfferSpendByOffer,
	type TOfferSpendByOfferAggregated,
} from '../types'

export const listOfferSpendByOffer = async (
	filter: ReturnType<typeof lib.filterSetup>,
	sort: ReturnType<typeof lib.sortSetup>,
	skip: ReturnType<typeof lib.skipSetup>,
	take: ReturnType<typeof lib.takeSetup>,
	signal: AbortSignal,
	token?: string | null,
): Promise<IFetchItems<TOfferSpendByOffer>> => {
	const headers = lib.bearer(token)
	const method: string = 'GET'
	const params: lib.FetchOptions['params'] = {
		f: filter,
		s: sort,
		skip,
		take
	}
	const uri: string = 'offer/spend/by/offer'

	const options: lib.FetchOptions = {
		headers,
		method,
		params,
		signal,
	}
	const data = await lib.fetching<IFetchItems<IFetchOfferSpendByOffer>>(uri, options)

	const rows = data?.items
		?.map((item: IFetchOfferSpendByOffer): TOfferSpendByOffer => {
			const { ...row } = item
			const result = {
				...row,
				agg: row.agg.map((agg: TFetchOfferSpendByOfferAggregated): TOfferSpendByOfferAggregated => {
					return {
						...agg,
						at: dt.utc(agg.at).toDate(),
						createdAt: dt.utc(agg.createdAt).toDate(),
						updatedAt: dt.utc(agg.updatedAt).toDate(),
					}
				}),
				offer: !row?.offer ? null : {
					...row.offer,
					createdAt: dt.utc(row.offer.createdAt).toDate(),
					updatedAt: dt.utc(row.offer.updatedAt).toDate(),
					deletedAt: row.offer.deletedAt ? dt.utc(row.offer.deletedAt).toDate() : null,
					scope: !row.offer.scope ? null : {
						...row.offer.scope,
						createdAt: dt.utc(row.offer.scope.createdAt).toDate(),
						updatedAt: dt.utc(row.offer.scope.updatedAt).toDate(),
					}
				}
			}
			return result
		})

	return {
		items: rows ?? [],
		total: data?.total ?? 0,
	}
}
